import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import type { IRenewalGeneralTabProps, TNotificationMode } from '@/@types/insurance';

export function RenewalGeneralTab({
  renewalDays,
  smsFallbackDays,
  onRenewalDaysChange,
  onSmsFallbackDaysChange,
  notificationMode,
  onNotificationModeChange,
}: IRenewalGeneralTabProps) {
  return (
    <div className="space-y-6 py-4">
      <div className="space-y-2">
        <Label htmlFor="notification-mode">Notification sending mode</Label>
        <Select
          value={notificationMode}
          onValueChange={val => onNotificationModeChange(val as TNotificationMode)} // AS_JUSTIFIED: Select value constrained to 'automatic'|'manual' by SelectItem values
        >
          <SelectTrigger id="notification-mode" className="max-w-[280px]">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="automatic">Automatic (daily cron)</SelectItem>
            <SelectItem value="manual">Manual (send button)</SelectItem>
          </SelectContent>
        </Select>
        <p className="text-xs text-muted-foreground">
          {notificationMode === 'automatic'
            ? 'Notifications are sent automatically every day at 8:00 AM UTC.'
            : 'Notifications are only sent when you click the "Send Notifications" button on the renewal page.'}
        </p>
      </div>

      <div className="space-y-2">
        <Label htmlFor="renewal-days">Days before expiry to show renewals</Label>
        <Input
          id="renewal-days"
          type="number"
          min={1}
          max={365}
          value={renewalDays}
          onChange={e => onRenewalDaysChange(parseInt(e.target.value, 10) || 1)}
          className="max-w-[140px]"
        />
        <p className="text-xs text-muted-foreground">
          Policies expiring within this many days appear in the renewals list. (1–365)
        </p>
      </div>

      <div className="space-y-2">
        <Label htmlFor="sms-fallback-days">SMS fallback delay (days)</Label>
        <Input
          id="sms-fallback-days"
          type="number"
          min={1}
          max={30}
          value={smsFallbackDays}
          onChange={e => onSmsFallbackDaysChange(parseInt(e.target.value, 10) || 1)}
          className="max-w-[140px]"
        />
        <p className="text-xs text-muted-foreground">
          After email is sent, send SMS if no renewal action taken within this many days. (1–30)
        </p>
      </div>
    </div>
  );
}
